function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

import React from "react";
import PropTypes from "prop-types";
import { jsx as ___EmotionJSX } from "@emotion/core";

var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "13o7eu2",
  styles: "display:block;"
} : {
  name: "13o7eu2",
  styles: "display:block;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9pY29ucy9jcml0aWNhbC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNTSIsImZpbGUiOiIuLi8uLi8uLi9zcmMvaWNvbnMvY3JpdGljYWwuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QgZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gXCJwcm9wLXR5cGVzXCI7XG5cbmZ1bmN0aW9uIENyaXRpY2FsKHsgc2l6ZSwgcHJpbWFyeUNvbG9yLCB0ZXN0SWQgfSkge1xuICByZXR1cm4gKFxuICAgIDxzdmdcbiAgICAgIGNzcz17e1xuICAgICAgICBkaXNwbGF5OiBcImJsb2NrXCIsXG4gICAgICB9fVxuICAgICAgd2lkdGg9e3NpemV9XG4gICAgICBoZWlnaHQ9e3NpemV9XG4gICAgICB2aWV3Qm94PVwiMCAwIDMyIDMyXCJcbiAgICAgIGZvY3VzYWJsZT1cImZhbHNlXCJcbiAgICAgIHJvbGU9XCJpbWdcIlxuICAgICAgZGF0YS10ZXN0aWQ9e3Rlc3RJZH1cbiAgICA+XG4gICAgICA8cGF0aFxuICAgICAgICBkPVwiTTIwLjMxMiA2bDUuOTI4IDUuOTI4djguMzgzbC01LjkyOCA1LjkyOGgtOC4zODNMNiAyMC4zMTF2LTguMzgzTDExLjkyOSA2aDguMzgzem0tLjgyOCAyaC02LjcyN0w4IDEyLjc1NnY2LjcyN2w0Ljc1NyA0Ljc1Nmg2LjcyN2w0Ljc1Ni00Ljc1NnYtNi43MjdMMTkuNDg0IDh6bS01LjQ4MyAxMS41YTEgMSAwIDAxLjExNyAxLjk5M2wtLjExNy4wMDdhMSAxIDAgMTEwLTJ6bTQgMGExIDEgMCAwMS4xMTcgMS45OTNsLS4xMTcuMDA3YTEgMSAwIDExMC0yem0uMDU4LTguNWMuNTIgMCAuOTQyLjQyMi45NDIuOTQzdjUuMTE1YzAgLjUyLS40MjEuOTQyLS45NDIuOTQyaC0uMTE1YS45NDMuOTQzIDAgMDEtLjk0My0uOTQydi01LjExNWMwLS41MjEuNDIyLS45NDMuOTQzLS45NDN6bS00IDBjLjUyIDAgLjk0Mi40MjIuOTQyLjk0M3Y1LjExNWMwIC41Mi0uNDIxLjk0Mi0uOTQyLjk0MmgtLjExNWEuOTQzLjk0MyAwIDAxLS45NDMtLjk0MnYtNS4xMTVjMC0uNTIxLjQyMi0uOTQzLjk0My0uOTQzelwiXG4gICAgICAgIGZpbGxSdWxlPVwiZXZlbm9kZFwiXG4gICAgICAgIGZpbGw9e3ByaW1hcnlDb2xvcn1cbiAgICAgIC8+XG4gICAgPC9zdmc+XG4gICk7XG59XG5cbkNyaXRpY2FsLnByb3BUeXBlcyA9IHtcbiAgc2l6ZTogUHJvcFR5cGVzLnN0cmluZy5pc1JlcXVpcmVkLFxuICBwcmltYXJ5Q29sb3I6IFByb3BUeXBlcy5zdHJpbmcuaXNSZXF1aXJlZCxcbiAgdGVzdElkOiBQcm9wVHlwZXMuc3RyaW5nLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgQ3JpdGljYWw7XG4iXX0= */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

function Critical(_ref) {
  var size = _ref.size,
      primaryColor = _ref.primaryColor,
      testId = _ref.testId;
  return ___EmotionJSX("svg", {
    css: _ref2,
    width: size,
    height: size,
    viewBox: "0 0 32 32",
    focusable: "false",
    role: "img",
    "data-testid": testId
  }, ___EmotionJSX("path", {
    d: "M20.312 6l5.928 5.928v8.383l-5.928 5.928h-8.383L6 20.311v-8.383L11.929 6h8.383zm-.828 2h-6.727L8 12.756v6.727l4.757 4.756h6.727l4.756-4.756v-6.727L19.484 8zm-5.483 11.5a1 1 0 01.117 1.993l-.117.007a1 1 0 110-2zm4 0a1 1 0 01.117 1.993l-.117.007a1 1 0 110-2zm.058-8.5c.52 0 .942.422.942.943v5.115c0 .52-.421.942-.942.942h-.115a.943.943 0 01-.943-.942v-5.115c0-.521.422-.943.943-.943zm-4 0c.52 0 .942.422.942.943v5.115c0 .52-.421.942-.942.942h-.115a.943.943 0 01-.943-.942v-5.115c0-.521.422-.943.943-.943z",
    fillRule: "evenodd",
    fill: primaryColor
  }));
}

Critical.propTypes = {
  size: PropTypes.string.isRequired,
  primaryColor: PropTypes.string.isRequired,
  testId: PropTypes.string
};
export default Critical;